import React from "react";

import Heading from "./Heading";
import ContentSection from "./ContentSection";
import Footer from "./Footer";
import styled from "styled-components";
import { Divider } from "@material-ui/core";

// import "../home.css";

const Page = styled.div`
  //   height: calc(100vh - 185px);
`;

const Content = styled.div`
  height: 100%;
  width: 100%;

  @media screen {
    overflow: auto;
  }
`;
const QuoteWrapper = styled.div`
  text-align: right;
  margin: 20px;
  width: 400px;
`;
const Quote = styled.div`
  margin-bottom: 20px;
  text-align: center;
  font-style: italic;
`;
const QuoteName = styled.div`
  font-weight: bold;
  text-align: center;
`;
const QuoteTitle = styled.div`
  text-align: center;
`;

const Description = styled.div`
  margin: 20px 20px 40px 20px;
`;

const Header = styled.div`
  font-size: 34px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 50px;
`;

const AboutUs = (props) => {
  return (
    <div>
      <Heading {...props} />
      <Page>
        <Content>
          <ContentSection minHeight={0}>
            <Header>About Us</Header>
            <Description>
              <p>
                RoboPPA™ is a sophisticated portfolio performance evaluation
                tool that is intended to improve an investor’s after fees,
                portfolio performance and wealth. This is accomplished by simple
                language, risk and return comparisons with purchasable and
                inexpensive Exchange Traded Funds.
              </p>
              <ul>
                <li style={{ maxWidth: 700, margin: "30px auto" }}>
                  The financial models developer is an engineer and finance PhD
                  consultant who has published extensively in leading academic
                  journals on the topic, was head of research at a major pension
                  and investment fund, and is a listed expert witness on
                  disputes involving managed investments.
                </li>
                <li style={{ maxWidth: 700, margin: "30px auto" }}>
                  The lead developer has 20 years experience creating highly
                  technical software from sophisticated mathematical and
                  qualitative models and using the latest technologies and
                  methodologies.
                </li>
              </ul>
            </Description>
          </ContentSection>
          <Divider />
          <ContentSection minHeight={0}>
            <div>
              <Header>Testimonials</Header>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <QuoteWrapper>
                  <Quote>
                    "I appreciated the analysis and insight provided in my
                    report, it was very beneficial to receive a detailed
                    evaluation of my portfolio’s performance from an independent
                    and low fee service like RoboPPA™"
                  </Quote>
                  {/* <QuoteName>John Smith</QuoteName>
                  <QuoteTitle>Investor</QuoteTitle> */}
                </QuoteWrapper>
                <QuoteWrapper>
                  <Quote>
                    "One of the world’s leading experts in this field having
                    published extensively in leading academic journals on the
                    topic, having worked for a major money management firm, and
                    having been an expert witness on disputes involving
                    investment return"
                  </Quote>
                  {/* <QuoteName>Jane Doe</QuoteName>
                  <QuoteTitle>Investment Advisor</QuoteTitle> */}
                </QuoteWrapper>
                <QuoteWrapper>
                  <Quote>
                    "….for those who need a privacy protected, risk-return
                    analysis of their self or externally managed portfolios."
                  </Quote>
                  {/* <QuoteName>Jane Doe</QuoteName>
                  <QuoteTitle>Investment Advisor</QuoteTitle> */}
                </QuoteWrapper>
                <QuoteWrapper>
                  <Quote>
                    "…data validation is very good! Very cool analysis! Overall,
                    this is a great tool!"
                  </Quote>
                </QuoteWrapper>
                <QuoteWrapper>
                  <Quote>"...a well put effort I must say, kudos"</Quote>
                </QuoteWrapper>
              </div>
            </div>
          </ContentSection>
          <Divider />
          <ContentSection minHeight={0}>
            <div>
              <Header>Questions, Concerns, Feedback</Header>
              <Description>
                <p>
                  If you have any questions or concerns, we can be reached via
                  email at{" "}
                  <a href="mailto:questions@roboppa.com">
                    questions@roboppa.com
                  </a>
                  .
                </p>
              </Description>
            </div>
          </ContentSection>
          <Divider />
          <ContentSection minHeight={0}>
            <div>
              <Header>Customer Support</Header>
              <Description>
                <p>
                  If you encounter any errors or have issues loading or using
                  the RoboPPA™ application, please email{" "}
                  <a href="mailto:support@roboppa.com">support@roboppa.com</a>{" "}
                  and provide the details. We will do our best to assist you in
                  a timely manner.
                </p>
              </Description>
            </div>
          </ContentSection>
          <Divider />
        </Content>
      </Page>
      <Footer />
    </div>
  );
};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/home/components/AboutUs.js